/**
 * @generated SignedSource<<079f6cd81b2329a33f5270a771e353eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsPackageOrderDue_order$data = {
  readonly packageDueDate: string | null | undefined;
  readonly " $fragmentType": "useIsPackageOrderDue_order";
};
export type useIsPackageOrderDue_order$key = {
  readonly " $data"?: useIsPackageOrderDue_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsPackageOrderDue_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsPackageOrderDue_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "packageDueDate",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "0d7846d02e9e1689c6a3072b5787c250";

export default node;
